import axios from 'axios'

const getTemplateUrl = ({ js_rept_url, api_url, token, aws_credentials }) => {
    const data_set_url = btoa(`${api_url}js-report`)
    const credentials = btoa(JSON.stringify(aws_credentials))
    return `${js_rept_url}/public-templates?access_token=${token}&dataset_url=${data_set_url}&credentials=${credentials}`
}

const state = {
    /*  stats: {
        users: 0,
        orders: 0,
        locations: 0,
        customers: 0,
    }, */
    js_base_url: '',
    rept_shared_token: null,
    aws_credentials: null,
    analyticsData: {},
}

const getters = {
    officers(state) {
        return state.analyticsData.officers
    },
    stats(state) {
        let { users, orders, locations, customers } =
            state.analyticsData.stats || {}
        users = users || 0
        orders = orders || 0
        locations = locations || 0
        customers = customers || 0
        return { users, orders, locations, customers }
    },
    orders(state) {
        return state.analyticsData.orders
    },
    orderTypes(state) {
        return state.analyticsData.orderTypes
    },
    roles(state) {
        return state.analyticsData.roles
    },
    assets(state) {
        return state.analyticsData.assets
    },
    assetTypes(state) {
        return state.analyticsData.assetTypes
    },
    reportUrl(state, getters, rootState) {
        const token = state.rept_shared_token
        const api_url = rootState.baseURL
        const js_rept_url = state.js_base_url
        const aws_credentials = state.aws_credentials
        return getTemplateUrl({ js_rept_url, api_url, token, aws_credentials })
    },
}

const mutations = {
    set_analytics(state, analyticsData) {
        state.analyticsData = analyticsData
    },
    set_report_token(state, rept_shared_token) {
        state.rept_shared_token = rept_shared_token
    },
    set_base_url(state, js_base_url) {
        state.js_base_url = js_base_url
    },

    set_stats(state, payload) {
        state.stats = payload
    },

    set_credentials(state, aws_credentials) {
        state.aws_credentials = aws_credentials
    },
}

const actions = {
    async getAnalyticData({ commit, state, rootState }, token) {
        const api_url = rootState.baseURL
        const js_rept_url = state.js_base_url
        const aws_credentials = state.aws_credentials
        const url = getTemplateUrl({
            js_rept_url,
            api_url,
            token,
            aws_credentials,
        })
        const resp = await axios.get(url)
        const cleanJson = JSON.parse(resp.data.replace(/&quot;/g, '"'))
        console.log('data--bbb--', cleanJson)
        commit('set_analytics', cleanJson)
    },

    async getDashboardData({ commit }) {
        const resp = await axios.get(`js-report/dashboard`)
        commit('set_analytics', resp.data.success.data)
    },

    async fetchCredentials({ commit }, rpt_type) {
        let qry = ''
        if (rpt_type) qry = `?rpt_type=${rpt_type}`
        if (rpt_type === 'statement') qry += '&include_pricing=1'
        const resp = await axios.get(`js-report/credentials${qry}`)
        const {
            url_prefix,
            aws_credentials,
            rept_shared_token,
        } = resp.data.success.data
        // basics
        commit('set_base_url', url_prefix)
        commit('set_credentials', aws_credentials)
        commit('set_report_token', rept_shared_token)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
